import { SVGFC } from '@repo/toolkit/types'

const SendIcon: SVGFC = ({ color, ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18.6649 5.33721C18.5138 5.18678 18.3242 5.08103 18.117 5.03158C17.9099 4.98213 17.6931 4.99089 17.4906 5.05691L5.8029 8.96514C5.58614 9.03399 5.39459 9.1657 5.25246 9.34362C5.11032 9.52154 5.02397 9.7377 5.00431 9.96479C4.98465 10.1919 5.03256 10.4197 5.14199 10.6195C5.25142 10.8193 5.41747 10.9822 5.61916 11.0874L10.4684 13.49L12.865 18.3673C12.9614 18.5582 13.1088 18.7185 13.2908 18.8302C13.4728 18.942 13.6822 19.0007 13.8956 19H13.9755C14.204 18.9831 14.4222 18.8977 14.6018 18.7549C14.7813 18.6121 14.9138 18.4184 14.9821 18.1991L18.9365 6.51448C19.0072 6.31261 19.0191 6.09478 18.971 5.88636C18.9229 5.67794 18.8168 5.4875 18.6649 5.33721ZM6.29821 10.0703L16.4999 6.65864L10.8359 12.3368L6.29821 10.0703ZM13.9515 17.7346L11.6827 13.1857L17.3468 7.50756L13.9515 17.7346Z"
        fill={color}
      />
    </svg>
  )
}

export default SendIcon
